"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsConditions = void 0;

var _baseReactComponents = require("@navinc/base-react-components");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _detailsTabs = require("../common/details-tabs");

var _jsxRuntime = require("react/jsx-runtime");

var TermsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TermsWrapper",
  componentId: "sc-1jko2k-0"
})(["padding:24px 8px;"]);

var TermsCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "TermsCopy",
  componentId: "sc-1jko2k-1"
})(["white-space:pre-line;"]);

var TermsConditions = function TermsConditions(_ref) {
  var loanOffer = _ref.loanOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab;
  var title = 'Terms & Conditions';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      shownTab: shownTab,
      title: title,
      handleShownTab: handleShownTab
    }), shownTab === title && /*#__PURE__*/(0, _jsxRuntime.jsx)(TermsWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TermsCopy, {
        size: "sm",
        children: loanOffer.navEditorial.termsAndConditions
      })
    })]
  });
};

exports.TermsConditions = TermsConditions;
//# sourceMappingURL=terms-conditions.js.map